import { useProject } from './useProject';

export function useActiveScene() {
  const project = useProject();

  if (!project) {
    return undefined;
  }

  return project.scenes.find(scene => scene.active);
}
